/*
 *     Copyright (c) 2020 Bcame S.r.l.. All rights reserved.
 *     Bcame S.r.l. Technology Business Unit
 *
 *     Company confidential.
 *
 *     This software is proprietary  to and embodies the confidential
 *     technology of Bcame S.r.l..  Possession, use, or copying of this
 *     software and media is authorized only pursuant to a valid written
 *     license from Bcame S.r.l.  or an authorized sublicensor.
 *
 *     Bcame S.r.l.
 */

<template>
  <div class="wrapp-tabs">
    <div class="price-tabs" :class="{ 'invalid-tab': hasError }">
      <b-tabs card v-model="tabSelected" @input="refreshActiveTab">
        <b-tab v-for="tab in tabs" :key="tab.title" :title="tab.title">
          <component :is="tab.components" @tile-selected="tileSelected" :activeItemId="value" :ref="`tab-${tab.value}`" />
        </b-tab>
      </b-tabs>
    </div>
    <div class="invalid-feedback" v-show="hasError">
      <div>{{hasErrorText}}</div>
    </div>
  </div>
</template>

<script>
import ProductTab from 'theme/components/Checkout/PriceAdjustements/Tabs/ProductTab.vue'
import ShipmentTab from 'theme/components/Checkout/PriceAdjustements/Tabs/ShipmentTab.vue'
import OrderTab from 'theme/components/Checkout/PriceAdjustements/Tabs/OrderTab.vue'

export default {
  name: 'TabsManager',
  inject: ['$validator'],
  $_veeValidate: {
    value () {
      return this.value
    },
    name () {
      return this.name
    }
  },
  props: {
    value: {
      type: String,
      required: true
    },
    name: {
      type: String
    },
    levelType: {
      type: String
    }
  },
  data () {
    return {
      tabIndex: 0,
      tabs: [
        {
          title: this.$t('price-adj.tab.products'),
          value: 'products',
          components: 'ProductTab'
        },
        {
          title: this.$t('price-adj.tab.shipments'),
          value: 'shipments',
          components: 'ShipmentTab'
        },
        {
          title: this.$t('price-adj.tab.order'),
          value: 'order',
          components: 'OrderTab'
        }
      ]
    }
  },
  computed: {
    hasError () {
      return this.errors.has('tabs-manager')
    },
    hasErrorText () {
      return this.errors.first('tabs-manager')
    },
    tabSelected: {
      get () {
        return this.tabIndex
      },
      set (newValue) {
        this.tabIndex = newValue
        this.tileSelected('')
        this.$emit('update:levelType', this.tabs[newValue].value)
      }
    }
  },
  methods: {
    refreshActiveTab (index) {
      let tabActive = this.tabs[index].value
      this.$validator.reset()
      if (this.$refs && this.$refs[`tab-${tabActive}`] && this.$refs[`tab-${tabActive}`].length) {
        let activeC = this.$refs[`tab-${tabActive}`][0]
        activeC.refresh && activeC.refresh()
      }
    },
    tileSelected (tab) {
      let selection = tab && tab.item_id ? tab.item_id : ''
      this.$emit('input', selection)
      this.$emit('activeTile', tab)
    }
  },
  components: {
    ProductTab,
    ShipmentTab,
    OrderTab
  }
}
</script>
